import React from 'react';
import { YesNoFilter } from '~/components';

export default function InvoicedFilter(props) {
  return <YesNoFilter icon="filter" placeholder="Invoiced" clearable {...props} />;
}
